import {Spinner} from '@wix/wix-ui-tpa/cssVars'
import React from 'react'
import {useWidgetState} from '../../hooks/state-provider'
import {isCalendarDatesLoaded} from '../../selectors/calendar-layout'
import s from './calendar.scss'
import {CalendarGrid} from './grid'
import {Header} from './header'

export const Calendar = () => {
  const loaded = useWidgetState(isCalendarDatesLoaded)

  return loaded ? (
    <div className={s.container}>
      <Header />
      <CalendarGrid />
    </div>
  ) : (
    <div className={s.loadingContainer}>
      <Spinner isCentered />
    </div>
  )
}
